import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72d8bbe1")

_pushScopeId("data-v-72d8bbe1")
const _hoisted_1 = {
  id: "aw-sl",
  style: {"font-size":"1em !important"}
}
const _hoisted_2 = {
  key: 0,
  class: "pw-lgtbx"
}
const _hoisted_3 = { class: "lgthbx-hldr" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  width: "128",
  height: "128",
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M75.7268 64.1048L125.567 14.2626C128.811 11.0206 128.811 5.77865 125.567 2.53662C122.325 -0.705404 117.083 -0.705404 113.841 2.53662L63.9993 52.3788L14.1586 2.53662C10.9151 -0.705404 5.67469 -0.705404 2.43266 2.53662C-0.810886 5.77865 -0.810886 11.0206 2.43266 14.2626L52.2733 64.1048L2.43266 113.947C-0.810886 117.189 -0.810886 122.431 2.43266 125.673C4.04836 127.29 6.17276 128.103 8.29564 128.103C10.4185 128.103 12.5414 127.29 14.1586 125.673L63.9993 75.8307L113.841 125.673C115.459 127.29 117.582 128.103 119.704 128.103C121.827 128.103 123.95 127.29 125.567 125.673C128.811 122.431 128.811 117.189 125.567 113.947L75.7268 64.1048Z",
    class: "stroke"
  })
], -1)
const _hoisted_5 = { class: "lgtbx-plr-cntnr" }
const _hoisted_6 = { class: "rnd-crns" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode("div", {
      id: "aw--c",
      style: _ctx.themeCss
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.isLightboxVisible == true && _ctx.currentVideo != null)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", {
                  class: "lgtbx-back-panel",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideLightbox && _ctx.hideLightbox(...args)), ["stop"]))
                }, [
                  _createVNode("div", {
                    class: "close",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideLightbox && _ctx.hideLightbox(...args)), ["stop"]))
                  }, [
                    _hoisted_4
                  ])
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_VideoPlayer, {
                      video_urls: _ctx.currentVideo.video_urls,
                      duration: _ctx.currentVideo.duration,
                      subtitles: _ctx.currentVideo.subitleUrls,
                      isgated: _ctx.isGated,
                      isTrailer: _ctx.isTrailer,
                      mid: _ctx.currentVideo.mid,
                      useDemoOverlay: _ctx.useDemoOverlay,
                      videoType: _ctx.currentVideo.type,
                      title: _ctx.currentVideo.title,
                      continuefromTime: _ctx.currentVideo.continuefromTime,
                      logoOverlay: _ctx.logoOverlay,
                      autoPlay: _ctx.isAutoPlay,
                      currentSubtitle: _ctx.currentSubtitle,
                      ma: _ctx.ma,
                      cta: _ctx.cta,
                      ref: _ctx.current_video,
                      post_play: _ctx.post_play,
                      isLightboxVideo: true
                    }, null, 8, ["video_urls", "duration", "subtitles", "isgated", "isTrailer", "mid", "useDemoOverlay", "videoType", "title", "continuefromTime", "logoOverlay", "autoPlay", "currentSubtitle", "ma", "cta", "post_play"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
})